<template>
  <div id="tools" v-if="userinfo.isAdmin && userinfo.isActive">
    <h1 class="mt-4" style="margin-bottom: 40px">Debug Tool Management</h1>
    <b-container>
      <div id="new">
        <b-button
          v-if="userinfo.isAdmin && userinfo.isActive"
          variant="primary"
          @click="newDebugTool"
          style="margin-bottom: 40px"
          >New Debug Tool</b-button
        >
      </div>
      <b-form class="text-left" style="margin-bottom: 20px; text-align: right">
        <b-input-group size="" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            v-model="filter"
            placeholder="Search Debug Tool"
          ></b-form-input>
        </b-input-group>
      </b-form>
      <b-table
        :fields="fields"
        :items="debug_tools"
        hover
        outlined
        :sort-by.sync="sortBy"
        :filter="filter"
      >
        <template #cell(action)="data">
          <!--
          <b-button size="sm" variant="primary" :href="`#/problem/${data.item.id}`">{{ data.value }}</b-button>
          -->
          <b-button
            size="sm"
            variant="success"
            @click="editDebugTool(data.item)"
            style="margin-left: 10px"
            >Edit Debug Tool</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            @click="
              debug_tool_title = data.item.title;
              debug_tool_id = data.item.id;
              $refs['warning'].show();
            "
            style="margin-left: 10px"
            >Delete</b-button
          >
          <b-button
            size="sm"
            variant="primary"
            @click="get_project_url(data.item.id)"
            style="margin-left: 10px"
            >GitLab</b-button
          >
        </template>
      </b-table>
      <b-modal
        ref="edit"
        id="edit"
        hide-footer
        :title="modal_title"
        size="lg"
      >
        <b-form style="text-align: left; margin-bottom: 10px" @submit="update_debug_tool">
          <b-form-group
            id="input-group-1"
            label="Title"
            label-for="debug_tool_title"
          >
            <b-form-input
              id="debug_tool_title"
              type="text"
              v-model="debug_tool_title"
              :state="debug_tool_title.length > 0"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="Description"
            label-for="debug_tool_desc"
          >
            <b-form-input
              id="debug_tool_desc"
              type="text"
              v-model="debug_tool_desc"
              :state="debug_tool_desc.length > 0"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-3"
            label="GitLab Project ID"
            label-for="project_id"
          >
            <b-form-input
              id="project_id"
              type="number"
              v-model="project_id"
              :state="!isNaN(project_id)"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-4"
            label="GitLab Project Branch"
            label-for="branch"
          >
            <b-form-input
              id="branch"
              type="text"
              placeholder="main, master, slave..."
              v-model="branch"
              :state="branch.length > 0"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-5"
            label="Job Name"
            label-for="job_name"
          >
            <b-form-input
              id="job_name"
              type="text"
              placeholder="the job name in GitLab CI"
              v-model="job_name"
              :state="job_name.length > 0"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-6"
            label="Cool Down Time (Minutes)"
            label-for="cooldown_time"
          >
            <b-form-input
              id="cooldown_time"
              type="number"
              placeholder="minutes"
              v-model="cooldown_time"
              :state="!isNaN(cooldown_time)"
            ></b-form-input>
            <b-input-group prepend="Variable Name" class="mt-4">
              <b-form-input
                v-model="variable"
                :state="this.variable.length > 0 && isNaN(this.variable)"
                placeholder="Using this variable to run debug tool"
              ></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-button
            v-if="new_tool"
            type="submit"
            variant="primary"
            class="mt-3"
            :disabled="checkTooplEmpty"
            >Add Debug Tool</b-button
          >
          <b-button
            v-else
            type="submit"
            variant="primary"
            class="mt-3"
            :disabled="checkTooplEmpty"
            >Update Debug Tool</b-button
          >
        </b-form>
      </b-modal>
      <b-modal ref="warning" id="warning" hide-footer title="Warning">
        <div class="text-center" style="font-size: 1.2rem">
          <p>This action will delete debug tool "{{ debug_tool_title }}".</p>
          <p>Are You Sure?</p>
        </div>
        <div class="col text-center">
          <b-button
            class="mt-3"
            variant="primary"
            @click="self.$refs['warning'].hide()"
            >No!</b-button
          >
          <b-button
            class="mt-3"
            variant="danger"
            @click="deleteDebugTool(debug_tool_id)"
            style="margin-left: 10px"
            >Delete!</b-button
          >
        </div>
      </b-modal>
      <b-modal ref="errorModal" id="errorModal" hide-footer title="Project Error">
        <div class="text-center" style="font-size: 1.2rem">
          <p>Please check this problem's config.</p>
          <p> Status Code: {{status_code}}</p>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
export default {
  created() {
    this.get_user_info();
    this.get_debug_tools();
  },
  beforeMount() {
    let self = this;
    this.$bus.$on("isAdmin", (event) => {
      self.is_admin = event.is_admin;
    });
  },
  mounted() {},
  beforeDestroy() {
    this.$bus.$off("isAdmin");
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
        },
        {
          key: "title",
          label: "Name",
        },
        {
          key: "job_name",
          label: "Job Name",
        },
        {
          key: "cooldown_minutes",
          label: "Cooldown Minutes",
        },
        {
          key: "project_id",
          label: "GitLab Project ID",
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      items: [],
      sortBy: "id",
      origin_tools_num: 0,
      userinfo: {
        isAdmin: false,
        isActive: false,
      },
      filter: "",
      debug_tools: [],
      debug_tool_title: "",
      project_id: 0,
      branch: "",
      job_name: "",
      cooldown_time: 0,
      new_tool: true,
      modal_title: "",
      variable: "",
      debug_tool_id: 0,
      debug_tool_desc: "",
      project_url: [],
      status_code: 0,
    };
  },
  computed: {
    checkTooplEmpty() {
      if (
        this.debug_tool_title.length > 0 &&
        !isNaN(this.project_id) &&
        this.debug_tool_desc.length > 0 &&
        this.branch.length > 0 &&
        this.job_name.length > 0 &&
        !isNaN(this.cooldown_time) &&
        this.variable.length > 0 &&
        isNaN(this.variable)
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    editDebugTool(item) {
      let self = this;
      this.debug_tool_id = item.id;
      this.debug_tool_title = item.title;
      this.debug_tool_desc = item.description;
      this.project_id = item.project_id;
      this.job_name = item.job_name;
      this.branch = item.branch;
      this.variable = item.variable;
      this.cooldown_time = item.cooldown_minutes;
      this.modal_title = "Edit Debug Tool";
      this.new_tool = false;
      self.$refs["edit"].show();
    },
    newDebugTool() {
      let self = this;
      this.debug_tool_id = 0;
      this.debug_tool_title = "";
      this.debug_tool_desc = "";
      this.project_id = 0;
      this.job_name = "";
      this.branch = "";
      this.variable = "";
      this.modal_title = "New Debug Tool";
      this.new_tool = true;
      self.$refs["edit"].show();
    },
    deleteDebugTool(id) {
      let self = this;
      let api = "/debug/";
      let access_token = localStorage.getItem("access_token");

      this.$http
        .delete(api + id, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          if (response != undefined) {
            self.get_debug_tools();
            self.$refs["warning"].hide();
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error);
          }
        });
    },
    get_user_info() {
      let self = this;
      let api = "/user/me";
      this.access_token = localStorage.getItem("access_token");
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + this.access_token,
          },
        })
        .then((response) => {
          self.userinfo = response.data;
          if (!self.userinfo.isAdmin) {
            self.$router.push({ name: "Home" });
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 422) {
              localStorage.clear();
              self.$router.push({ name: "Home" });
            }
          }
        });
    },
    toComponent(c_name) {
      let userinfo = this.userinfo;
      this.$router.push({
        name: c_name,
        params: { userinfo },
      });
    },
    get_debug_tools() {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/";

      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          self.debug_tools = response.data;
          this.origin_tools_num = response.data.length;
        });
    },
    get_project_url(id) {
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/" + id + "/url";
      this.$http
        .get(api, {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((response) => {
          window.open(response.data, "_blank").focus();
        }).catch(function (error) {
          if (error.response) {
            self.status_code = error.response.status;
            self.$refs["errorModal"].show();
          }
        });
    },
    update_debug_tool(event) {
      event.preventDefault();
      let self = this;
      let access_token = localStorage.getItem("access_token");
      let api = "/debug/";
      let data = {
        title: this.debug_tool_title,
        description: this.debug_tool_desc,
        project_id: this.project_id,
        job_name: this.job_name,
        branch: this.branch,
        cooldown_minutes: this.cooldown_time,
        variable: this.variable,
      };
      if (this.debug_tool_id == 0) {
        self.$http
          .post(api, data, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then((response) => {
            self.debug_tools = response.data;
            self.$refs["edit"].hide();
            this.debug_tool_title = "";
            this.debug_tool_desc = "";
            this.project_id = 0;
            this.job_name = "";
            this.branch = "";
            this.cooldown_time = 0;
            this.variable = "";
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      } else {
        self.$http
          .patch(api + self.debug_tool_id, data, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          })
          .then((response) => {
            self.debug_tools = response.data;
            self.$refs["edit"].hide();
            this.debug_tool_title = "";
            this.debug_tool_desc = "";
            this.project_id = 0;
            this.job_name = "";
            this.branch = "";
            this.cooldown_time = 0;
            this.variable = "";
          })
          .catch(function (error) {
            if (error.response) {
              //console.log(error);
            }
          });
      }
    },
  },
};
</script>

<style>
tr {
  vertical-align: middle;
}
</style>
